import { Link } from "react-router-dom";
import { useSponsors } from "../../../hooks/useSponsors";

interface AdSectionProps {
  variant?: "top" | "bottom";
}

export default function AdSection({ variant = "top" }: AdSectionProps) {
  const { sponsors, loading } = useSponsors("Home");

  return (
    <section className="bg-white py-5 md:py-8">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6">
        {/* Divider header */}
        <div className="flex items-center justify-between mb-3 md:mb-5">
          <div className="flex items-center gap-3">
            <div className="h-px w-8 bg-slate-200" />
            <span
              className="text-slate-400 text-[10px] font-bold tracking-widest uppercase"
              style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
            >
              Espacios Publicitarios
            </span>
            <div className="h-px w-8 bg-slate-200" />
          </div>
          <Link
            to="/publicidad"
            className="inline-flex items-center gap-1.5 px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-[11px] font-bold rounded-lg cursor-pointer whitespace-nowrap transition-all"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            <i className="ri-megaphone-line" />
            ¿Anunciarte aquí?
          </Link>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[1, 2, 3].map((i) => (
              <div key={i} className="h-52 bg-slate-100 rounded-xl animate-pulse" />
            ))}
          </div>
        ) : sponsors.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {sponsors.slice(0, 3).map((sponsor) => (
              <a
                key={sponsor.id}
                href={sponsor.website_url || "#"}
                target="_blank"
                rel="nofollow noreferrer"
                className="relative rounded-xl overflow-hidden border border-slate-100 group cursor-pointer hover:-translate-y-1 transition-all duration-300 block"
              >
                <div
                  className="absolute top-3 left-3 z-10 bg-black/50 text-white text-[9px] font-bold px-2 py-0.5 rounded-full tracking-widest uppercase backdrop-blur-sm"
                  style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
                >
                  Publicidad
                </div>
                <div className="w-full h-40 overflow-hidden">
                  {sponsor.banner_url ? (
                    <img
                      src={sponsor.banner_url}
                      alt={sponsor.company_name}
                      className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                    />
                  ) : (
                    <div className="w-full h-full bg-gradient-to-r from-[#0B1F3A] to-[#1a3a6b] flex items-center justify-center">
                      <p className="text-white font-bold text-sm">{sponsor.company_name}</p>
                    </div>
                  )}
                </div>
                <div className="p-4 bg-gradient-to-r from-[#0B1F3A] to-[#1a3a6b]">
                  <div className="flex items-start justify-between gap-2">
                    <div>
                      <p className="text-white font-bold text-sm" style={{ fontFamily: "'Sora', sans-serif" }}>
                        {sponsor.company_name}
                      </p>
                      {sponsor.notes && (
                        <p className="text-white/60 text-xs mt-0.5" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                          {sponsor.notes}
                        </p>
                      )}
                    </div>
                    <div className="w-7 h-7 flex items-center justify-center bg-white/10 rounded-lg flex-shrink-0 group-hover:bg-white/20 transition-colors mt-0.5">
                      <i className="ri-arrow-right-up-line text-white text-sm" />
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[1, 2, 3].map((slot) => (
              <Link
                key={slot}
                to="/publicidad"
                className="relative rounded-xl overflow-hidden border border-dashed border-slate-200 group cursor-pointer hover:border-red-300 hover:bg-red-50/30 transition-all duration-300 block"
              >
                <div className="h-52 flex flex-col items-center justify-center text-center p-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-slate-100 rounded-xl mb-3 group-hover:bg-red-100 transition-colors">
                    <i className="ri-megaphone-line text-slate-400 text-xl group-hover:text-red-500 transition-colors" />
                  </div>
                  <p className="text-slate-500 font-semibold text-sm" style={{ fontFamily: "'Sora', sans-serif" }}>
                    Espacio disponible
                  </p>
                  <p className="text-slate-400 text-xs mt-1" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                    {slot === 1
                      ? "Sector Aeronáutico"
                      : slot === 2
                      ? "Turismo & Viajes"
                      : "Formación Aeronáutica"}
                  </p>
                  <span className="mt-3 inline-flex items-center gap-1 text-red-500 text-[11px] font-semibold">
                    Anunciar aquí <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}